var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEinreichen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M139.21,146h51.512v42.747H139.21Z",
    transform: "translate(-139.21 -146)",
    fill: "#00c4de"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Einreichen_pop_up",
    "data-name": "Einreichen pop up",
    transform: "translate(-6013 -6700)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(6013 6700)",
    fill: "#e8fcff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "download_8_",
    "data-name": "download (8)",
    transform: "translate(5898.034 6579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4550",
    "data-name": "Group 4550",
    transform: "translate(139.21 146)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M140.628,171.608c-1.951,1.024-1.87,2.522.175,3.332l6.06,2.4a7.764,7.764,0,0,0,6.879-.984L180.056,155.6c1.73-1.361,1.915-1.16.413.449l-20.8,22.265a2.515,2.515,0,0,0,.991,4.367l.71.277c2.053.794,5.4,2.128,7.441,2.957l6.72,2.736a3.474,3.474,0,0,0,4.8-2.273l10.243-37.649c.578-2.124-.545-3.026-2.5-2Z",
    transform: "translate(-139.215 -146.271)",
    fill: "#00c4de"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M268.266,497.017c-.12.359,4.144-6.174,4.144-6.174a3.191,3.191,0,0,0-1.516-4.871l-4.65-1.9c-2.037-.833-3.013.145-2.17,2.18C264.074,486.248,268.389,496.648,268.266,497.017Z",
    transform: "translate(-111.013 -301.031)",
    fill: "#5f5f5f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEinreichen);
export default __webpack_public_path__ + "static/media/Icon_Einreichen.2f1d73345705dc6faf4da00973e6186a.svg";
export { ForwardRef as ReactComponent };